module.exports = __webpack_public_path__ + "img/電気回路_5_7_4.1742b135.png";